import React, { useCallback } from 'react';
import { CustomEventName, customEventPayloadV2 } from '@fullstory/searchiecache';
import { FsEvent } from '@fullstory/fs-script-api';
import { SearchieCacheButton } from '../SearchieCacheButton';
import { AppCacheStatus } from '@fullstory/redux';
import { appCacheStatusToButtonStatus } from '../../utils';
import { Duration, duration, Timestamp } from '@fullstory/proto/google/protobuf';

interface CacheButtonProps {
  hovered: boolean;
  timestamp: Date | null;
  status: AppCacheStatus;
  onCacheSwap: () => void;
  onRefresh: () => void;
  /* duration to wait before allowing a forced refresh */
  refreshableAfter: duration | null;
}

export const ResourceCacheButton: React.FC<CacheButtonProps> = ({
  hovered,
  timestamp,
  status,
  onCacheSwap,
  onRefresh,
  refreshableAfter,
}) => {
  const nowFunc = useCallback(() => new Date(), []);
  const cacheButtonProps: React.ComponentProps<typeof SearchieCacheButton> = {
    nowFunc,
    cardHover: hovered,
    timestamp: Timestamp.fromDate(timestamp)!,
    refreshableAfter: refreshableAfter ?? Duration.fromSeconds(0),
    onShowClick: () => {
      if (timestamp) {
        FsEvent.recordCustomEventV2(
          CustomEventName,
          ...customEventPayloadV2(new Date(), timestamp, 'swap'),
        );
      }
      onCacheSwap();
    },
    onRefreshClick: () => {
      if (timestamp) {
        FsEvent.recordCustomEventV2(
          CustomEventName,
          ...customEventPayloadV2(new Date(), timestamp, 'refresh'),
        );
      }
      onRefresh();
    },
    status: appCacheStatusToButtonStatus(status),
  };

  return <SearchieCacheButton data-component="ResourceCacheButton" {...cacheButtonProps} />;
};
